/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash/_freeGlobal.js
// module id = 8f6X
// module chunks = 1